/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Next_PermutationInputs */



/**
* | output |
* | --- |
* | "Next changeover on {date}" |
*
* @param {Next_PermutationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const next_permutation = /** @type {((inputs: Next_PermutationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_PermutationInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Next changeover on ${i?.date}`)
	return /** @type {LocalizedString} */ (`Prochaine permutation le ${i?.date}`)
});